import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentButtonState = createSelector(
  (state: AppState) => state.ai.button,
  button => button.state,
)
